import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchMenuItemsMissingRecipes } from '@/renderer/services/menuServicePaginated';
import type { MissingRecipesFilterParams } from '@/renderer/types/pagination';

export function useMenuItemsMissingRecipes(params: MissingRecipesFilterParams) {
  return useQuery({
    queryKey: queryKeys.menu.missingRecipes(params),
    queryFn: async () => {
      const result = await fetchMenuItemsMissingRecipes(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch menu items missing recipes',
        );
      }
      return result.data;
    },
    // A null/undefined outletId is a valid company-wide view (e.g. a super
    // user viewing "All Outlets"), not "not ready yet" — always enabled.
    placeholderData: keepPreviousData,
  });
}
